var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRtf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-795 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(795 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(763.64 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.958,8.882h-.6V6a.418.418,0,0,0-.005-.054.478.478,0,0,0-.116-.315L46.454.167l0,0a.47.47,0,0,0-.1-.081L46.321.063a.508.508,0,0,0-.1-.04L46.2.014A.484.484,0,0,0,46.087,0H34.322a.975.975,0,0,0-.974.974V8.881h-.6a1.392,1.392,0,0,0-1.392,1.392V17.51A1.392,1.392,0,0,0,32.752,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.388a.975.975,0,0,0,.974-.974V18.9h.6A1.392,1.392,0,0,0,53.35,17.51V10.273A1.391,1.391,0,0,0,51.958,8.882Zm-1.57,14.711H34.322V18.9H50.388v4.69Zm-10.8-8.357c.206.744.411,1.605.538,1.86H38.6a8.247,8.247,0,0,1-.46-1.537c-.176-.822-.46-1.048-1.067-1.058h-.451v2.595H35.144v-6.51a13.1,13.1,0,0,1,1.987-.137,3.367,3.367,0,0,1,2.134.519,1.675,1.675,0,0,1,.608,1.381,1.751,1.751,0,0,1-1.166,1.625V14A1.663,1.663,0,0,1,39.588,15.235Zm.863-3.485V10.5h5.072V11.75h-1.8v5.345h-1.5V11.75Zm9.733,1.478v1.214H47.814v2.654h-1.5V10.5H50.35V11.72H47.814v1.508h2.369Zm.2-4.346H34.322V.974H45.6V5.956a.487.487,0,0,0,.487.487h4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M148.225,255.124a3.742,3.742,0,0,0-.675.049v1.821h.588c.744,0,1.184-.372,1.184-.949C149.322,255.437,148.911,255.134,148.225,255.124Z",
    transform: "translate(-110.928 -243.57)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.6893a6c672113d69cc16a75dc7b2edcb.svg";
export { ForwardRef as ReactComponent };